import { styled } from '@slal/ui';
import { Modal as SLALModal, ModalBody as SLALModalBody, ModalFooter as SLALModalFooter } from '@slal/ui/modal';

export const Modal = styled(SLALModal)`
    & > div:nth-child(2) {
        width: 100%;
        max-width: 900px;
    }
`;

export const ModalBody = styled(SLALModalBody)`
    & > div:nth-child(1) {
        display: flex;
        flex-direction: column;
        gap: 24px;
    }
`;

export const ModalFooter = styled(SLALModalFooter)`
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`;
